module.exports = __webpack_public_path__ + "static/media/F2.129551b5.webp";